import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { FormCheck } from 'react-bootstrap';
function EmployerSignUpPreviewandSubmit() {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  return (
    <Container fluid className='m-0 p-0' >
      <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
        <Container>
          <h2 class="text-white pt-3">Sign Up</h2>
        </Container>
      </div>

      <Container className='p-4'>

        <Row>
          <Col sm={3} className='progressbar-bg'>
            <ul class="StepProgress">
              <li class="StepProgress-item is-done">Company Details</li>
              <li class="StepProgress-item is-done">Industry Focus</li>
              <li class="StepProgress-item is-done">Contact Person Details</li>
              <li class="StepProgress-item is-done">Account Security</li>
              <li class="StepProgress-item is-done"> Preview and Submit</li>
            </ul>
          </Col>
          <Col sm={5} style={{ margin: 'auto' }}>
            <h6 style={{ color: '#025EA9' }}>Employeer</h6>
            <Container className='m-auto'>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row>
                  <Card className='rounded p-4' style={{ backgroundColor: '#EBF2F7', border: '1px solid #025EA9' }}>
                    <h6>Preview and Submit</h6>
                    <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                      <Col sm={11} className='fw-bold'>Company Details</Col>
                      <Col sm={1}><Card.Link as={Link} to="/EmployerSignUpCompanyDetails" className='mr-2'><i class="bi bi-pencil-square"></i></Card.Link></Col>
                    </Row>
                    <Row className='mt-2 p-2'>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Company Name *</strong></p>
                        <span>Pharma</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Employer EIN *</strong></p>
                        <span>253558</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Business Type *</strong></p>
                        <span>Commercial</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Industry *</strong></p>
                        <span>Pharma</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Business Address *</strong></p>
                        <span>Address here</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>City *</strong></p>
                        <span>Dallas</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>State *</strong></p>
                        <span>Texas</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Zip Code *</strong></p>
                        <span>75001</span>
                      </Col>
                    </Row>
                    <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                      <Col sm={11} className='fw-bold'>Industry Focus</Col>
                      <Col sm={1}><Card.Link as={Link} to="/EmployerSignUpIndustryFocus" className='mr-2'><i class="bi bi-pencil-square"></i></Card.Link></Col>
                    </Row>
                    <Row className='mt-2 p-2'>
                      <Col sm={6}>

                        <span>Pharma</span>
                      </Col>
                      <Col sm={6}>

                        <span>Biotech</span>
                      </Col>



                    </Row>

                    <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                      <Col sm={11} className='fw-bold'>Contact Person Details</Col>
                      <Col sm={1}><Card.Link as={Link} to="/EmployerSignUpContactPersonDetails" className='mr-2'><i class="bi bi-pencil-square"></i></Card.Link></Col>
                    </Row>
                    <Row className='mt-2 p-2'>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>First Name *</strong></p>
                        <span>Vijay</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Last Name *</strong></p>
                        <span>Kolla</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Job Title *</strong></p>
                        <span>Managing Director</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Email Address *</strong></p>
                        <span>vijaykolla@gmail.com</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Phone Number *</strong></p>
                        <span>+1 25358 2558</span>
                      </Col>


                    </Row>

                    <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                      <Col sm={11} className='fw-bold'>Account Security</Col>
                      <Col sm={1}><Card.Link as={Link} to="/EmployerSignUpAccountSecurity" className='mr-2'><i class="bi bi-pencil-square"></i></Card.Link></Col>
                    </Row>

                    <Row className='mt-2 p-2'>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Set Password *</strong></p>
                        <span>Vijay</span>
                      </Col>
                      <Col sm={6}>
                        <p className='p-0 m-0'><strong>Confirm Password *</strong></p>
                        <span>Vijay</span>
                      </Col>



                    </Row>
                  </Card>

                </Row>

                <Row className='mt-2 '>
                  <Col sm={1} style={{textAlign:'right'}}>
                    {['checkbox'].map((type) => (
                      <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                          inline
                          label=" "
                          name="group1"
                          type={type}
                          id={`inline-${type}-1`}
                        />


                      </div>
                    ))}
                  </Col >
                  <Col sm={11}>I agree to the <Card.Link as={Link} to="/" >Terms and Conditions </Card.Link>
                  </Col>
                </Row>
                <Row>
                  <Col className='text-center mt-4'>



                    <Card.Link as={Link} to="/EmployerSignUpAccountSecurity" className='mr-4 pr-4'><i class="bi bi-arrow-left"></i> Back  </Card.Link>
                    <Button type="submit" className='rounded-button ml-2'> Submit <i class="bi bi-arrow-right"></i></Button>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Col>
        </Row>
      </Container>




    </Container>

  );


}

export default EmployerSignUpPreviewandSubmit